
import { defineComponent } from 'vue'
import { Menu, MenuItems, MenuItem } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSearch, faTimesCircle, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { Input } from '@design-system/ui'

export default defineComponent({
  name: 'InputAutocomplete',
  components: {
    Menu,
    MenuItems,
    MenuItem,
    Input,
    FontAwesomeIcon
  },
  props: {
    label: {
      type: String,
      required: false
    },
    labelClass: {
      type: String,
      required: false,
      default: 'text-gray-900'
    },
    searchValue: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Digite aqui para pesquisar'
    },
    mask: {
      type: String,
      required: false,
      default: ''
    },
    isIncorrect: {
      type: Boolean,
      required: false,
      default: false
    },
    incorrectMessage: {
      type: String,
      required: false,
      default: 'Campo incorreto!'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    inputEvent: {
      type: String,
      required: true
    },
    resultEvent: {
      type: String,
      required: true
    },
    minimumCharactersToShowList: {
      type: Number,
      required: false,
      default: 5
    },
    searchFunction: {
      type: Function,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    listValues: {
      type: Array,
      required: false
    },
    listQuantity: {
      type: Number,
      required: false,
      default: 3
    }
  },
  data () {
    return {
      icons: {
        search: faSearch,
        cancel: faTimesCircle,
        loading: faCircleNotch
      },
      search: this.searchValue,
      isOpen: false
    }
  },
  watch: {
    searchValue () {
      this.search = this.searchValue
    },
    search () {
      this.$emit(`${this.inputEvent}`, this.search)
    }
  },
  methods: {
    result (value) {
      this.isOpen = false
      this.$emit(`${this.resultEvent}`, value)
    },
    reset () {
      this.search = ''
      this.$emit(`${this.inputEvent}`, '')
    },
    closeDropdown () {
      setTimeout(() => {
        if (!this.$el.contains(document.activeElement)) this.isOpen = false
      }, 100)
    },
    focusInput () {
      const element = this.$el
      element.getElementsByTagName('input')[0].focus()
    }
  }
})
